import { MAPS_LINK_MEXICO } from '../links';

const mexicoFooter = {
  contactInformation: [
    {
      title: 'Dirección',
      address: 'Varsovia No. 36 Piso 4, Int. 408, Colonia Juárez C.P. 6600, Ciudad de México',
      navigateTo: MAPS_LINK_MEXICO,
    },
    {
      title: 'Contacto',
      phone: '+52 56 4861 2937',
      email: 'contacto@fingo.com.mx',
    },
  ],
};

export default mexicoFooter;
